'use strict';

var frame = require('./frame.cjs');
var globalConfig = require('../../../../motion-utils/dist/es/global-config.cjs');

let now;
function clearTime() {
    now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */
const time = {
    now: () => {
        if (now === undefined) {
            time.set(frame.frameData.isProcessing || globalConfig.MotionGlobalConfig.useManualTiming
                ? frame.frameData.timestamp
                : performance.now());
        }
        return now;
    },
    set: (newTime) => {
        now = newTime;
        queueMicrotask(clearTime);
    },
};

exports.time = time;
//# sourceMappingURL=sync-time.cjs.map
